// extracted by mini-css-extract-plugin
export default {"dynamicSurvey__button":"dynamicSurvey__button-yDjFAx","dynamicSurvey__logo":"dynamicSurvey__logo-CChJFe"};